import { Button } from "@mui/material";
import React, { useState } from "react";
import Verify from "./Verify";
import useTranslations from "../Translations/useTranslations";

const Otp = ({ setFormSubmit }) => {
  const [otpSubmit, setOtpSubmit] = useState(false);
  const { translations } = useTranslations();

  return (
    <div>
      {otpSubmit ? (
        <Verify setFormSubmit={setFormSubmit} setOtpSubmit={setOtpSubmit} />
      ) : (
        <div>
          <h1>{translations.verifyAccountTitle}</h1>
          <h3>
          {translations.verifyAccountMessage}
          </h3>
          {/* <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
        {otp.map((digit, index) => (
          <input
            key={index}
            id={`otp-input-${index}`}
            type="text"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            style={{
              width: "40px",
              height: "40px",
              fontSize: "20px",
              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        ))}
      </div> */}
          <div style={{ marginTop: "20px" }}>
            <Button
              onClick={() => {
                setFormSubmit(false);
              }}
              type="submit"
              variant="contained"
              sx={{
                background: "linear-gradient(90deg, #4A7BA8, #244C77)",
                color: "#fff",
                fontSize: "16px",
                textTransform: "none",
                padding: "5px 30px",
                borderRadius: "20px",
                marginTop: "1rem",
              }}
            >
              {translations.ok}
            </Button>

          </div>
        </div>
      )}
    </div>
  );
};

export default Otp;
